import router from '@/router'
import store from '@/store/index'
import { getCookies, setCookies, getCookiesDecrypt } from '@/util/cookies'
import { TR } from '@/constant/constant'
const newRouter = [
  {
    path: '/',
    name: 'layout',
    component: () => import('@/view/layout.vue'),
    children: [],
  },
]

export default {
  authorize(dynamicStateRouters) {
    setCookies('SR', JSON.stringify(false))
    router.beforeEach((to, from, next) => {
      const token = getCookies('token')
      if (to.path !== '/login') {
        if (!token) next('/login')
        else {
          if (to.meta.index) setCookies('menuIndex', to.meta.index)
          store.commit('common/setPageName', to.meta.title)

          if (!JSON.parse(getCookies('SR'))) {
            let userRoleCode = getCookiesDecrypt(TR) || ''
            let newChildren = dynamicStateRouters.filter(item => {
              if ((item.meta.role && item.meta.role.includes(userRoleCode)) || item.meta.role.includes('all'))
                return true
              else return false
            })
            newRouter[0].children = newChildren
            router.addRoutes(newRouter)
            setCookies('SR', JSON.stringify(true))
            next({ ...to, replace: true })
          } else {
            next()
          }
        }
      } else {
        if (token) next('/')
        else next()
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/router/identity.js